export default {
  message: {
    menu: ["关于我们", "产品", "联系", "可用", "家"],
    section2: {
      title: ["健康", "素食", "為每個人"],
      text: [
        "由有機蘑菇製成 由米糠製成，不含肥料，不含農藥，包含蛋白質，維生素B1，B2，纖維和鐵，對健康有益",
        "由金針菇製成 還有蘑菇",
        "只選幼蘑菇 聞到氣味 以及最好的風味，美味和可口的食物。所有年齡段的人都可以使用。"
      ]
    },
    section3: {
      title: ["金针菇", "酥脆平菇", "金针菇", "酥脆平菇"],
      sub: ["原版的", "原版的", "辣", "东炎"],
      button: "产品"
    },
    section4: {
      title: "可在"
    },
    footer: {
      r1: "隐私权和条款",
      r2:
        "42/3 Phahonyathin 11, Phahonyothin Road, Phayathai, Phayathai, Bangkok 10400",
      r3: "社会"
    },
    about: {
      section1: {
        text: 
          "Mayanakarn Co.，Ltd在2015年8月19日向市場推出了健康零食的新選擇，並成為脆皮蘑菇片行業的領導者。 我們的業務是製造和分銷香菇零食，香脆牡蠣蘑菇等蘑菇零食產品。 以Mayanakarn自己的品牌命名為“ HUAHED”。 我們承諾以高品質繼續生產我們的產品超過4年，我們從一開始就開始進行質量控製程序。 我們的零食是由精心挑選的新鮮有機蘑菇製成，加工過程中帶有我們的秘密收據，在封閉區域內種植，沒有任何添加劑和防腐劑。 我們的業務方式從頭到尾都來自質量控制，創新和價格控制等方面，以滿足客戶的最高滿意度。 每個人都可以享受。 Mayanakarn Co.,Ltd zài 2",
        title: "关于我们"
      },
      section2: {
        title: "關於我們",
        text: [
          "Mayanakarn Co.，Ltd在2015年8月19日向市場推出了健康零食的新選擇，並成為脆皮蘑菇片行業的領導者。 我們的業務是製造和分銷香菇零食，香脆牡蠣蘑菇等蘑菇零食產品。 以Mayanakarn自己的品牌命名為“ HUAHED”。 我們承諾以高品質繼續生產我們的產品超過4年，我們從一開始就開始進行質量控製程序。 我們的零食是由精心挑選的新鮮有機蘑菇製成，加工過程中帶有我們的秘密收據，在封閉區域內種植，沒有任何添加劑和防腐劑。 我們的業務方式從頭到尾都來自質量控制，創新和價格控制等方面，以滿足客戶的最高滿意度。 每個人都可以享受。 Mayanakarn Co.,Ltd zài 2"
        ]
      }
    },
    product: {
      title: "产品",
      button: "可在",
      item: [
        {
          title: "江之菇原味",
          text:
            "香脆的Enoki蘑菇原始風味（綠色包裝），由健康的Enoki蘑菇，高蛋白維生素B和纖維以及鐵製成，老少皆宜，歡迎素食主義者，貨架期長達12個月"
        },
        {
          title: "牡蠣蘑菇“冬陰功”風味",
          text:
            "脆皮牡蠣蘑菇Tomyum香精（橙色裝）由健康的牡蠣蘑菇，高蛋白，維生素C和纖維以及鐵製成，老少皆宜，歡迎素食主義者，貨架壽命長達12個月。"
        },
        {
          title: "牡蠣蘑菇原味",
          text:
            "脆皮牡蠣蘑菇原味（黃色包裝），由健康的牡蠣蘑菇，高蛋白，維生素C和纖維以及鐵，老少咸宜，素食主義者製成，可保存12個月。"
        },
        {
          title: "江之菇香辣味",
          text:
            "香脆的Enoki蘑菇辛辣味（紅色包裝），由健康的Enoki蘑菇，高蛋白維生素B，高纖維以及鐵製成，在所有年齡段都美味，歡迎素食主義者，貨架期長達12個月。"
        }
      ]
    },
    contact: {
      title: ["联系", "留言"],
      address: [
        {
          title: "地址",
          text:
            "42/3 Phahonyathin 11, Phahonyothin Road, Phayathai, Phayathai, Bangkok 10400"
        },
        {
          title: "电子邮件",
          text: "sales@mayanakarn.com"
        },
        {
          title: "电话",
          text: "0922749396"
        }
      ],
      form: ["你的名字", "学科", "学科", "您的手机", "你的信息"],
      button: "发送"
    },
    available: {
      title: "在商店里找到",
      text:
        "我們的小吃可在Tops超市，中央食品大廳，美食市場，居家市場，Siam Paragon 7-11，Tesco，Big C和全國400多家雜貨店買到。"
    },
    privacy: {
      title: "PRIVACY & TERMS",
      content: [
        {
          title: "Privacy Policy of huahed",
          child: [
            `huahed operates the http://mayanakarn.com/ website, which provides the SERVICE.
            This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the huahed website.`,
            `If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.`,
            `The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at huahed.vasin.me, unless otherwise defined in this Privacy Policy. Our Privacy Policy was created with the help of the Privacy Policy Template.`
          ]
        },
        {
          title: "Information Collection and Use",
          child: [
            `For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.`
          ]
        },
        {
          title: "Log Data",
          child: [
            `We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.`
          ]
        },
        {
          title: "Cookies",
          child: [
            `Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.`,
            `Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.`
          ]
        },
        {
          title: "Service Providers",
          child: [
            `We may employ third-party companies and individuals due to the following reasons`,
            ` - To facilitate our Service;`,
            ` - To provide the Service on our behalf;`,
            ` - To perform Service-related services; or`,
            ` - To assist us in analyzing how our Service is used.`,
            `We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.`
          ]
        },
        {
          title: "Security",
          child: [
            `We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.`
          ]
        },
        {
          title: "Links to Other Sites",
          child: [
            `Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.`
          ]
        },
        {
          title: "Children’s Privacy",
          child: [
            `Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.`
          ]
        },
        {
          title: "Changes to This Privacy Policy",
          child: [
            `We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.`
          ]
        },
        {
          title: "Contact Us",
          child: [
            `If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.`
          ]
        }
      ]
    }
  }
};
